import { ajax } from "../../app/core/ajax";
import * as maskUtil from "../components/mask";
import { deepClone } from "../core/core";
import _ from "lodash";
import axios from "axios";

export function loadDeferredLink(args) {

    var deferredLink = args.deferredLink || (args.deferredObject ? args.deferredObject.__deferred : null);

    if (!deferredLink) {
        return $.Deferred().resolve({
            d: {
                results: deepClone((args.deferredObject || {}))
            }
        });
    }

    const { expand, filter, inlinecount, select, sort, top } = args;

    const params = {
        $expand: expand,
        $filter: filter,
        $inlinecount: inlinecount,
        $select: select,
        $sort: sort,
        $top: top,
    };

    const path = deferredLink.uri || deferredLink;
    const filteredParams = _.omitBy(params, v => !v);
    const url = axios.getUri({url: path, params: filteredParams });

    maskUtil.maskElements(args);

    return ajax({
        url,
        beforeSend: args.beforeSend,
        type: "GET"
    }).done(function () {
        maskUtil.unmaskElements(args);
    });
}
